import React from "react";
import { Navigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const ToDoWorklistMain: React.FC = () => {
  // Redirect to tasks page by default
  return <Navigate to={all_routes.todoWorklist.tasks} replace />;
};

export default ToDoWorklistMain;
